/* eslint-disable @typescript-eslint/no-explicit-any */
import { parsePhoneNumberFromString } from 'libphonenumber-js/core';
import metadata from 'libphonenumber-js/metadata.min.json';

// Same check and metadata as `isValidPhoneNumber` of react-phone-number-input (PhoneNumberField)
function isValidPhoneNumber(value: string): boolean {
  if (!value) return false;
  const phoneNumber = (parsePhoneNumberFromString as any)(value, metadata);
  if (!phoneNumber) return false;
  return phoneNumber.isValid();
}

/**
 * Phone number validation of PhoneNumberField.
 * Legacy array values (`['FR0', '612345678']`) are joined first.
 */
export function isValidPhoneValue(value: unknown, defaultValue?: unknown): boolean {
  if (!value) return false;
  const stringValue = (Array.isArray(value) ? value.join('').replace('FR0', '+33') : value) || defaultValue;
  return !stringValue || (stringValue as string).length === 0 || isValidPhoneNumber(stringValue as string);
}
